import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/blog", label: "Articles" },
  { to: "/heatmap", label: "Heatmap" },
  { to: "/research", label: "Research" },
  { to: "/about", label: "About" },
];

const DesktopNav = () => {
  const location = useLocation();

  return (
    <div className="hidden sm:flex sm:items-center gap-1">
      {navLinks.map((link) => {
        const isActive = location.pathname === link.to || 
          (link.to !== "/" && location.pathname.startsWith(link.to));
        
        return (
          <Link
            key={link.to}
            to={link.to}
            className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
              isActive
                ? "text-accent bg-secondary"
                : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
            }`}
          >
            {link.label}
          </Link>
        );
      })}
    </div>
  );
};

export default DesktopNav;
